import REQUEST_STATUS from 'utils/constants/requestStatusTypes';

export const showActionStatuses = [REQUEST_STATUS.inProgress]

export const disableCommentsStatuses = [REQUEST_STATUS.delivered, REQUEST_STATUS.rejected]

export default null;
